import React from "react";
import "./style.css";
import ieltsClassImage from "../../../assets/ielts-class.webp";
import hearingImage from "../../../assets/hearing.webp";
import mockTestImage from "../../../assets/mocktest.webp";

const TestPreparations = () => {
  return (
    <div className="testpreparations container">
      <div className="row align-items-center p-0">
        <div className="col-12 col-lg-5">
          <h6 className="title mb-3">Test Preparations</h6>
          <h2 className="subtitle mb-4">IELTS, PTE & Mock Test</h2>
          <p className="description">
            Please enroll IELTS, PTE and Mock Tests with us and secure the best
            scores to be eligible for any courses you are aspiring to study
            abroad.
          </p>
        </div>
        <div className="col-12 col-lg-7 d-lg-block d-none">
          <div className="row p-0">
            <div className="col-12 col-lg-6">
              <div className="ielts-image-container">
                <img src={ieltsClassImage} alt="ielts-class" />
              </div>
            </div>
            <div className="col-12 col-lg-6">
              <div className="row flex-column">
                <div className="col-12 col-lg-12 p-2">
                  <div className="hearing-image-container">
                    <img src={hearingImage} alt="hearing-test" />
                  </div>
                </div>
                <div className="col-12 col-lg-12 p-2">
                  <div className="mock-test-image-container">
                    <img src={mockTestImage} alt="mock-test" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestPreparations;
